import { render, staticRenderFns } from "./orderPay.vue?vue&type=template&id=0d6e5f16&scoped=true"
import script from "./orderPay.vue?vue&type=script&lang=js"
export * from "./orderPay.vue?vue&type=script&lang=js"
import style0 from "./orderPay.vue?vue&type=style&index=0&id=0d6e5f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6e5f16",
  null
  
)

export default component.exports